import { AuthProvider, DataProvider, fetchUtils, LoginComponent } from "react-admin";

export interface TokenProvider {
  getIdToken(): Promise<string>;
}

export interface AppContext {
    authProvider: AuthProvider;
    dataProvider: DataProvider;
    tokenProvider?: TokenProvider;
    loginPage?: LoginComponent;
    httpClient?: (url: string, options?: fetchUtils.Options) => Promise<{ status: number, headers: Headers, body: any }>;
}

export interface AppContextProvider {
    getAppContext(): Promise<AppContext>;
}

export const getAppContextHeaders = (url:string, headers:Headers) => {
  const tenantId = sessionStorage.getItem('current-tenant');
  const brandId = sessionStorage.getItem('current-brand');

  // JK TODO: wire in better approach to determine which urls to no include x-teant header on
  const excludeTenantHeader = url && url.includes('tenant-dp');

  if (tenantId && !excludeTenantHeader) {
    headers.set('x-tenant-id', tenantId);
  }

  if (brandId) {
    headers.set('x-brand-id', brandId);
  }

    // Return the modified headers object
    return headers;

}

class AppContextProviderRegistry {
    private static providers: Map<string, AppContextProvider> = new Map();
  
    static registerProvider(key: string, provider: AppContextProvider) {
      if (this.providers.has(key)) {
        console.log(`AuthProvider with key ${key} is already registered.`);
        return;
      }
      this.providers.set(key, provider);
    }
  
    static getProvider(key: string): AppContextProvider {
      console.log('getprovider', key);
      console.log('providers', this.providers);
      const provider = this.providers.get(key);

      if (!provider) {
        throw new Error(`AppContextProvider with key ${key} is not registered.`);
      }
      return provider;
    }
  }
  
  export default AppContextProviderRegistry;